import { Organization } from "@madhive/mad-sdk";
import { GET_ORGANIZATION_SUCCESS } from "./types";

export const setGetOrganizationSuccess = (organization: Organization) => ({
  type: GET_ORGANIZATION_SUCCESS,
  payload: organization
});
